import React from 'react';

export default ({ color = '#191919' }) => (
    <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.5 20C1.95 20 1.479 19.8043 1.087 19.413C0.695667 19.021 0.5 18.55 0.5 18V4H2.5V18H13.5V20H2.5ZM6.5 16C5.95 16 5.47933 15.8043 5.088 15.413C4.696 15.021 4.5 14.55 4.5 14V2C4.5 1.45 4.696 0.979 5.088 0.587C5.47933 0.195667 5.95 0 6.5 0H15.5C16.05 0 16.521 0.195667 16.913 0.587C17.3043 0.979 17.5 1.45 17.5 2V14C17.5 14.55 17.3043 15.021 16.913 15.413C16.521 15.8043 16.05 16 15.5 16H6.5ZM6.5 14H15.5V2H6.5V14Z"
            fill={color}
        />
    </svg>
);
